import React from 'react';
import { useTranslation } from 'react-i18next';
import FormGroupWithTooltip from '@/components/common/FormGroup/FormGroupWithTooltip';
import Select from '@/components/common/Select/Select';
import { FormGroupProps } from './types';

type Props = FormGroupProps & {
  metadataLanguages: any[];
  loadMetadataLanguages: (inputText: string | null, callback: any) => void;
  handleAlbumMetaData: (field: string, value: string | null) => void;
};

export default function MetadataLanguageFormGroup({
  album,
  readonly,
  disabled,
  metadataLanguages,
  loadMetadataLanguages,
  showValidationErrors,
  fieldHasErrors,
  findErrorMessage,
  handleAlbumMetaData,
}: Props) {
  const { t } = useTranslation();

  return (
    <FormGroupWithTooltip
      tooltipKey="tooltip.product.metadataLanguage"
      hasErrors={
        fieldHasErrors('MetadataLanguage') ||
        (showValidationErrors && !album.albumMetaData?.metadataLanguage)
      }
    >
      {(metadataLanguages?.length ?? 0) > 0 && (
        <Select
          id="metadataLanguageTypeahead"
          labelTitle={t('product.editProduct.metadataLanguage')}
          labelClass="col-sm-3 form-label"
          isClearable={!disabled}
          loadOptions={loadMetadataLanguages}
          placeholder=""
          onChange={(e: any) => {
            handleAlbumMetaData('metadataLanguage', e?.value);
          }}
          initialOption={metadataLanguages?.find(
            (ml) => ml.value === album.albumMetaData?.metadataLanguage
          )}
          className="col-sm-6"
          isDisabled={disabled}
          isReadOnly={readonly}
          hasErrors={fieldHasErrors('MetadataLanguage')}
          errorMessage={findErrorMessage('MetadataLanguage')}
          isRequired={true}
          showValidationErrors={showValidationErrors}
          fieldValidationKey={'productEditMode.MetadataLanguage'}
        ></Select>
      )}
    </FormGroupWithTooltip>
  );
}
